import * as React from 'react';
import type { SVGProps } from 'react';
const SvgCocktails = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <g clipPath="url(#cocktails_svg__a)">
      <path
        fill="#263E6A"
        d="M18.651 5h-2.674a.23.23 0 0 0-.18.085L13.219 8.22h-1.868a.234.234 0 0 0 0 .467h1.484l-1.378 1.674a.234.234 0 0 0 .362.297l1.62-1.97h1.673l-3.336 4.117-3.958-5.412a.234.234 0 0 0-.377.276L8.782 9.5A2.144 2.144 0 0 1 5.467 7.71c0-1.179.963-2.138 2.147-2.138s2.146.96 2.146 2.138a.234.234 0 0 0 .467 0 2.61 2.61 0 0 0-2.613-2.605A2.61 2.61 0 0 0 5 7.709a2.612 2.612 0 0 0 4.058 2.17l2.475 3.384v3.45l-1.987 1.884a.233.233 0 0 0 .16.403h4.319a.234.234 0 0 0 .153-.41L12 16.706V13.27l4.531-5.592a.234.234 0 1 0-.363-.294l-.677.836h-1.667l2.264-2.751h2.563a.234.234 0 0 0 0-.468m-8.358 13.533 1.48-1.405 1.624 1.405z"
      />
    </g>
    <defs>
      <clipPath id="cocktails_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgCocktails;
